export default __webpack_public_path__ + "static/media/decada-2000-0006-min.691ed3b7.jpg";